<template>
    <form @submit.prevent="onSubmit">
        <div v-if="viewData.Errors && viewData.Errors.length > 0">
            <h3>Es sind folgende Fehler aufgetreten</h3>
            <p v-for="msg in viewData.Errors">{{msg}}</p>
            <p>Bitte korrigieren Sie Ihre Eingaben und schicken Sie das Formular noch einmal ab.</p>
            <p><a href="">Noch einmal versuchen</a><br /><br /></p>
        </div>

        <h3>Schritt 1 (Benutzername)</h3>
        <div class="form input-text-double-1">
            <span class="input">
                <label>Bitte tragen Sie hier Ihren Benutzernamen ein</label>
                <input type="text" v-model="model.benutzername" required />
            </span>
            <span></span>
        </div>
        <div class="form input-submit">
            <input type="submit" name="input-submit" id="input-submit">
        </div>
    </form>
</template>

<script lang="ts">
    import ApiService from '@/services/apiService';
import { getFormHashString } from '@/services/formSession';
    import { defineComponent } from 'vue';

    const PasswortVergessenStage1 = defineComponent({
        name: "PasswortVergessenStage1",
        data() {
            return {
                model: {} as { benutzername: string, sessionId: string },
                viewData: {} as any,
            }
        },

        props: {
            sessionId: String
        },
        methods: {
            async onSubmit() {
                // "TestBenutzername", "ZugangsdatenVergessenForm"
                this.model.sessionId = this.sessionId ? getFormHashString(this.sessionId) : "";
                const model = this.model;
                this.viewData = await ApiService.Instance.PostData("/umbraco/login/zugangsdatenvergessenform/testbenutzername", model);

                this.$emit("updateSessionId", this.viewData.sessionId);

                if (this.viewData.redirectTo) {
                    window.location.href = this.viewData.redirectTo;
                }
            }
        },

    });
    export default PasswortVergessenStage1
</script>